module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "addr-search"
    }
  }, [_c('xm-input', {
    ref: "search",
    attrs: {
      "name": "uid"
    },
    on: {
      "blur": function($event) {
        return _vm.hideSuggestions(200)
      }
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "suggestion-menu"
  }, [(_vm.showDropdown) ? _c('ul', {
    ref: "dropdown",
    attrs: {
      "id": "search-dropdown"
    }
  }, _vm._l((_vm.suggestions), function(item) {
    return _c('li', {
      key: item.addr_id,
      staticClass: "suggestion",
      on: {
        "click": function($event) {
          _vm.choice = item
        }
      }
    }, [_vm._v(_vm._s(item.formatted))])
  }), 0) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d88a60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/AddressAutoComplete.vue
// module id = 1304
// module chunks = 16